import { type ReactNode } from "react";
import { Button, Segmented, Space } from "antd";
import { ChevronLeft, ChevronRight } from "lucide-react";

import { type CalendarView } from "./calendarModel";

const VIEW_OPTIONS: { value: CalendarView; label: string }[] = [
  { value: "month", label: "Miesiąc" },
  { value: "week", label: "Tydzień" },
  { value: "agenda", label: "Agenda" },
];

interface CalendarToolbarProps {
  title: string;
  view: CalendarView;
  views: CalendarView[];
  onViewChange: (view: CalendarView) => void;
  onPrev: () => void;
  onNext: () => void;
  onToday: () => void;
  extra?: ReactNode;
}

export const CalendarToolbar = ({
  title,
  view,
  views,
  onViewChange,
  onPrev,
  onNext,
  onToday,
  extra,
}: CalendarToolbarProps) => (
  <div className="flex flex-wrap items-center justify-between gap-3">
    <div className="flex min-w-0 flex-wrap items-center gap-2">
      <Button onClick={onToday}>Dziś</Button>
      <Space.Compact>
        <Button aria-label="Poprzedni" icon={<ChevronLeft size={16} className="align-[-3px]" />} onClick={onPrev} />
        <Button aria-label="Następny" icon={<ChevronRight size={16} className="align-[-3px]" />} onClick={onNext} />
      </Space.Compact>
      <h2 className="m-0 ml-1 whitespace-nowrap text-lg font-semibold text-gray-900 first-letter:uppercase">{title}</h2>
    </div>
    <div className="flex flex-wrap items-center gap-3">
      {extra}
      <Segmented<CalendarView>
        value={view}
        onChange={onViewChange}
        options={VIEW_OPTIONS.filter((option) => views.includes(option.value))}
      />
    </div>
  </div>
);
